export type GlobalSearchType =
  | 'application'
  | 'applicant'
  | 'report'
  | 'subscriber'
  | 'property'
  | 'screening'
  | 'pricing'
  | 'invoice'
  | 'user'
  | 'queue'
  | 'page';

export interface GlobalSearchAction {
  id: string;
  label: string;
  primary?: boolean;
  payload?: any;
}

export interface GlobalSearchItem {
  id: string;
  type: GlobalSearchType;
  title: string;
  subtitle?: string;
  status?: string;
  score?: number;
  route?: { path: string; query?: Record<string, any> };
  actions: GlobalSearchAction[];
  entity?: Record<string, any>;
  keywords?: string[];
}

export interface GlobalSearchGroup {
  type: GlobalSearchType | string;
  label: string;
  total: number;
  items: GlobalSearchItem[];
}

export interface GlobalSearchResponse {
  q: string;
  tookMs?: number;
  groups: GlobalSearchGroup[];
}

export interface GlobalSearchFlatRow {
  groupLabel: string;
  item: GlobalSearchItem;
  flatIndex: number;
}

export interface GlobalSearchSuggestion {
  type: string;
  id: string;
  label: string;
  value: string;
  meta?: Record<string, any>;
}

export interface GlobalSearchAdvancedResponse {
  page: number;
  limit: number;
  total: number;
  tookMs?: number;
  items: GlobalSearchItem[];
  hasMore?: boolean;
}

export interface GlobalSearchSavedItem {
  id: number;
  name: string;
  filters: Record<string, any>;
  createdAt?: string;
  updatedAt?: string;
}

/**
 * The search API joins subtitle segments with a bullet that sometimes arrives
 * mangled as the Unicode replacement character (rendered as a "?" tofu glyph).
 * Normalize it to a clean separator before display.
 */
export function cleanGlobalSearchText(value: string | null | undefined): string {
  if (!value) {
    return '';
  }
  return value
    .replace(/\s*\uFFFD+\s*/g, ' \u2022 ')
    .replace(/\s{2,}/g, ' ')
    .trim();
}
